import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Grid, Paper } from '@material-ui/core';

import CONFIG from '../../cfg/config';

//import Gallery from './gallery';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import { roomsService, webRoomDetails, AsortGrupyWiersz } from '../../api';
import { AppState, Actions, store, PanelState, IPageState } from '../../appredux'

import {AddItem} from '../PanelRightBasket';

import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
//import DialogChangeItem from '../dialog/changeItem';
import DialogChangeItem from '../dialog/ChangeItem';
import Gallery from './gallery';
import roomImg from 'app/assets/noImage.jpg';
import Details from './Details';

import { fontSelect } from '../../fonts';
import theme from 'themes';
import { hexToRgb } from 'app/common/helpers';

import './KartaDanie.css'

interface KartaDanieProp {
    key : number,
    classes? : any,
    danie : AsortGrupyWiersz,
    ostatni: boolean,
    t? : any,
    lang? : string,
    page: IPageState,
    view: number,
    selected: boolean,
    setItem: (item: AsortGrupyWiersz) => void,
    scroll: boolean,
    setScroll: () => void
}

const opisPrzyciskuContained : string = 'do koszyka'; 

class KartaDanie extends React.Component<KartaDanieProp/* & WithTranslation*/, any> {
  textTheme = fontSelect(this.props.page.fonts, 7, 1) as React.CSSProperties;
  selectedTheme = fontSelect(this.props.page.fonts, 13, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 8, 2) as React.CSSProperties;

  constructor(props : any) {
      super(props, {});
      this.state = {
        //width: window.innerWidth,
        openChange: false,
        item: {},
        visible: false,
        openDetails: false,
        lastDetails: false
      }
      //this.updateWindowWidth = this.updateWindowWidth.bind(this);
   }

   componentDidUpdate(prevProps : KartaDanieProp){

   }

  componentDidMount() {
    //this.updateWindowWidth();
    //window.addEventListener('resize', this.updateWindowWidth);

    if(this.props.selected && this.props.scroll){
      const element = document.getElementById(this.props.danie.asort_id.toString())
      if(element) element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
      this.props.setScroll()
    }
  }
  
  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateWindowWidth);
  }
  
  updateWindowWidth() {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  openGalery = () => {
    if (this.state.openDetails)
      this.setState({ visible: true, openDetails: false, lastDetails: true })
    else
      this.setState({ visible: true }) 
  }

  closeGalery = () => {
    if (this.state.lastDetails)
      this.setState({ visible: false, openDetails: true, lastDetails: false })
    else
      this.setState({ visible: false })
  }
  
  openDetails = () => {
    this.setState({ openDetails: true })
  }

  closeDetails = () => {
    this.setState({ openDetails: false })
  }

  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
    }

  // addItemFunc = (row: any) => {
  //   if (row.nazwa_do_zm == 1) {
  //     this.setState({ openChange: true, item: row })
  //   } else {
  //     let menuItem = this.props.page.menuItems.find((e: any) => e.menu_id == this.props.page.selectedMenuItem)
  //     if (menuItem && this.props.page.minItems < menuItem.zamowienie_min_ilosc_pozycji) {
  //       store.dispatch(Actions.pageState.setMinItems(menuItem.zamowienie_min_ilosc_pozycji));
  //     }
  //     AddItem(row);
  //   }
  // }

  animmacjaDodania = () => {
    let img = document.getElementById(this.props.danie.asort_id.toString() + "img")

    if(img){

    let parent = img.parentElement
    let imgAnimation = img.cloneNode(false) as HTMLElement

    let w = ((img.offsetWidth -10)*1.3).toString() + "px"
    let h = ((img.offsetHeight -10)*1.3).toString() + "px"

    let tw = ((img.offsetWidth -10)).toString() + "px"
    let th = ((img.offsetHeight -10)).toString() + "px"

    let t = (img.offsetTop - 0.15 * (img.offsetHeight -10)).toString() + "px"
    let tt = img.offsetTop.toString() + "px"

    let l =  (img.offsetLeft - 0.15 * (img.offsetWidth -10)).toString() + "px"
    let tl = img.offsetLeft.toString() + "px"
    
    imgAnimation.style.cssText = `--from-width:${w}; --to-width:${tw};--from-height:${h}; --to-height:${th};--from-top:${t}; --to-top:${tt};--from-left:${l}; --to-left:${tl};`;

    imgAnimation.style.position = "absolute"
    imgAnimation.style.zIndex = "1000"
    //imgAnimation.style.width = w
    //imgAnimation.style.height = h
    //imgAnimation.style.top = img.offsetTop.toString() + "px"
    //imgAnimation.style.left = img.offsetLeft.toString() + "px"

    

    //imgAnimation.style.animationName = "lol"
    //imgAnimation.style.animationDuration = "4s"
    imgAnimation.classList.add("animation");

    parent?.appendChild(imgAnimation)

    setTimeout(() => {
      try {
        parent?.removeChild(imgAnimation) 
      } catch (error) {
      }

    }, 3000);

    }
    
  }

  closeDialogChangeItem = () => {
    this.setState({openChange: false})
  }

  render() {
    const {t, classes}  = this.props;

    let color = this.textTheme.color 
    let lightGray = "#888"
    if(this.props.selected && this.selectedTheme.color){
      color = this.selectedTheme.color //theme.palette.primary.main
      lightGray = this.selectedTheme.color //theme.palette.primary.main
    }

    
    let s1 = `2px 2px 3px 2px #e6e6e6`
    let s2 = `2px 2px 3px 2px rgba(230, 230, 230, 0.6)`

    let mainColorRgb = hexToRgb(color!)
    if(!mainColorRgb){
      mainColorRgb = {r: 230, g: 230, b: 230}
    } 
  
    s2 = `2px 2px 3px 2px rgba(${mainColorRgb.r}, ${mainColorRgb.g}, ${mainColorRgb.b}, 0.65)`

 
    return (
      <Fragment key={this.props.key}>

        {this.props.view === 1 ? 
          <Paper id={this.props.danie.asort_id.toString()} className={classes.paper} elevation={0} style={this.props.ostatni ? { marginBottom: "0" } : {}}>
            <Card
              key={this.props.danie.asort_id}
              elevation={0}
              //classes={{ root: classes.card }}
            >
              <Grid container spacing={2} className={classes.gridContainer}>
                <Grid
                  item sm={12} md={4}  //xs={12} sm={4} 
                  className={classes.grid} style={{width: "calc(100% + -6px)"}}
                  // style={(this.state.width <= 600) ?
                  //   { paddingBottom: "0px", minWidth: "130.8px", paddingRight: "16px" } :
                  //   { paddingBottom: "0px", minWidth: "324px" }}
                >
                  {/* <CardMedia
          style={(this.state.width <= 600)?
            {width: "112.5px", height: "63px", margin: "10px 0px 5px 10px"}:
            {width: "250px", height: "140px", margin: "10px 20px 5px 10px"}}
          className={classes.media}
          //image={this.props.danie.foto}
          image={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.danie.asort_id}/th_foto.jpg`}
          title={this.props.danie.asort_nazwa}
        /> */}
                  <img id={this.props.danie.asort_id.toString() + "img"}

                    // style={(this.state.width <= 600) ?
                    //   { width: "112.5px", height: "63px", margin: "10px 0px 5px 10px" } :
                    //   { width: "250px", height: "140px", margin: "10px 20px 5px 10px" }}
                    className={classes.media}
                    style={{boxShadow: this.props.selected? s1 : s1}}
                    onClick={this.openGalery}

                    title={this.props.danie.asort_nazwa}
                    src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.danie.asort_id}/th_foto.jpg`}
                    onError={this.ImgError}
                  />

                </Grid>
                <Grid
                  item sm={12} md={8} //xs={12} sm={8}
                  // style={{
                  //   width: "auto", paddingBottom: "0px", paddingLeft: "0px",
                  //   paddingRight: "52px"
                  // }}
                  className={classes.grid2}
                >
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom variant="h6" component="h6" color="primary"
                      className={classes.headline}
                      style={{...this.contentTheme, color: color}}
                    >
                      {this.props.danie.asort_nazwa}
                    </Typography>
                    <hr />
                  </Grid>

                  
                  <Grid item xs={12} style={{ display: "flex" }}>
                    <Grid
                      item //xs={12} sm={10} className={classes.grid3}
                      //style={{ height: '100%', width: '100%' }}
                      style={{width: "calc(100% + -65px)"}}
                    >
                      <div style={{ paddingRight: "12px"}} className={classes.infoOuter}>
                        <Typography color='textSecondary' className={`${classes.infoInner} ${classes.lightGray}`} style={{color: lightGray}}
                          dangerouslySetInnerHTML={{ __html: this.props.danie.info }}>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      item //xs={12} sm={2} className={classes.grid3}
                      //style={{ height: '100%', width: '100%' }}
                      style={{width: "65px"}}
                    >
                      <CardActions
                        className={classes.actions}
                        style={{ height: "84px", padding: '0', textAlign: 'end' }}
                      >
                        <Typography
                          color="primary" align='center' variant='body1'
                          style={{ marginBottom: '20px', paddingTop: "4px", ...this.contentTheme, color: color }}
                        >
                          <b>{this.props.danie.cena + ' zł'}</b>
                        </Typography>
                        <Button
                          variant="outlined" size="medium" color="primary"
                          onClick={() => { this.props.setItem(this.props.danie); AddItem(this.props.danie); this.animmacjaDodania()  }}
                          className={classes.actionButtons}
                          style={{ marginBottom: '40.71px', marginLeft: "0", border: "0", color: color }}>
                          <AddShoppingCartIcon style={{width: "1.5em", height: "1.5em"}}/>
                        </Button>
                        {/*<Gallery className={classes.actions} button={true} title={ lPhotos }
              icon="icon-picture" room={ this.props.room.www_rodz_pokoi_id.toString() } />*/}
                      </CardActions>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
            <hr className={classes.hr} style={this.props.ostatni ? { width: '100%', marginBottom: "0" } : { width: '100%' }} />

          </Paper>

        
        
        : ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        this.props.view === 2 ? 
          <Grid key={this.props.key} item xs={12} md={6} style={{paddingBottom: "0px"}}>
            <Paper id={this.props.danie.asort_id.toString()} className={classes.paper} elevation={0}>
              <Card
                key={this.props.danie.asort_id}
                elevation={0}
              //classes={{ root: classes.card }}
              >

                <Grid container spacing={2} className={classes.gridContainer}>

                  <Grid
                    item xs={12} sm={12}
                    className={classes.grid}
                  >
                    <Typography
                      gutterBottom variant="h6" component="h6" color="primary"
                      className={classes.headline}
                      style={{...this.contentTheme, color: color}}
                    >
                      {this.props.danie.asort_nazwa}
                    </Typography>
                    <hr style={{marginBottom: "0"}} />

                  </Grid>

                  <Grid
                    item 
                    className={classes.grid} style={{ width: "calc(100% + -82px)", display: "inline-block", paddingRight: "0px", paddingTop: "4px" }}
                  >
                    
                    <img id={this.props.danie.asort_id.toString() + "img"}
                      className={classes.media}
                      style={{boxShadow: this.props.selected? s1 : s1}}
                      onClick={this.openGalery}

                      title={this.props.danie.asort_nazwa}
                      src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.danie.asort_id}/th_foto.jpg`}
                      onError={this.ImgError}
                    />
                  </Grid>
                  
                  <Grid
                    item  //sm={2} className={classes.grid3}
                    //style={{ height: '100%', width: '100%' }}
                    style={{ width: "82px", paddingTop: "2px" }}
                  >
                    <CardActions
                      className={classes.actions}
                      style={{ height: "100%", padding: '0', textAlign: 'end' }}
                    >
                      <Typography
                        color="primary" align='center' variant='body1'
                        style={{ marginBottom: '15px', ...this.contentTheme, color: color, }}
                      >
                        <b>{this.props.danie.cena + ' zł'}</b>
                      </Typography>
                      <Button
                        variant="outlined" size="medium" color="primary"
                        onClick={() => { this.props.setItem(this.props.danie); AddItem(this.props.danie); this.animmacjaDodania() }}
                        className={classes.actionButtons}
                        style={{ marginBottom: '0', marginLeft: "0", border: "0", color: color, }}>
                        <AddShoppingCartIcon style={{width: "1.5em", height: "1.5em"}}/>
                      </Button>
                      <div style={{  height: "calc(100% + -90px)", display: "flex", marginLeft: 0, marginTop: "12px", position: "relative" }} >
                        <Typography color='textSecondary' className={`${classes.text} ${classes.lightGray}`} style={{cursor: "pointer", marginBottom: 0, color: lightGray}}
                          onClick={this.openDetails}
                          dangerouslySetInnerHTML={{ __html: this.props.danie.info }}>
                        </Typography>
                      </div>
                    </CardActions>
                  </Grid>


                </Grid>
              </Card>
              {/* <hr className={classes.hr} style={{ width: '100%' }} /> */}

            </Paper>

          </Grid>  : ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        this.props.view === 3 ? 
              <Grid key={this.props.key} item xs={12} md={6} lg={4} style={{ paddingBottom: "0px" }}>
                <Paper id={this.props.danie.asort_id.toString()} className={classes.paper} elevation={0}>
                  <Card
                    key={this.props.danie.asort_id}
                    elevation={0}
                  //classes={{ root: classes.card }}
                  >

                    <Grid container spacing={2} className={classes.gridContainer}>

                      <Grid
                        item xs={12} sm={12}
                        className={classes.grid}
                      >
                        <Typography
                          gutterBottom variant="h6" component="h6" color="primary"
                          className={classes.headline}
                          style={{ ...this.contentTheme, color: color }}
                        >
                          {this.props.danie.asort_nazwa}
                        </Typography>
                        <hr style={{ marginBottom: "0" }} />

                      </Grid>

                      <Grid
                        item
                        className={classes.grid} style={{ width: "calc(100% + -82px)", display: "inline-block", paddingRight: "0px", paddingTop: "4px" }}
                      >

                        <img id={this.props.danie.asort_id.toString() + "img"}
                          className={classes.media}
                          style={{ boxShadow: this.props.selected ? s1 : s1 }}
                          onClick={this.openGalery}

                          title={this.props.danie.asort_nazwa}
                          src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.danie.asort_id}/th_foto.jpg`}
                          onError={this.ImgError}
                        />
                      </Grid>

                      <Grid
                        item  //sm={2} className={classes.grid3}
                        //style={{ height: '100%', width: '100%' }}
                        style={{ width: "82px", paddingTop: "2px" }}
                      >
                        <CardActions
                          className={classes.actions}
                          style={{ height: "100%", padding: '0', textAlign: 'end' }}
                        >
                          <Typography
                            color="primary" align='center' variant='body1'
                            style={{ marginBottom: '10px', ...this.contentTheme, color: color, }}
                          >
                            <b>{this.props.danie.cena + ' zł'}</b>
                          </Typography>
                          <Button
                            variant="outlined" size="medium" color="primary"
                            onClick={() => { this.props.setItem(this.props.danie); AddItem(this.props.danie); this.animmacjaDodania() }}
                            className={classes.actionButtons}
                            style={{ marginBottom: '0', marginLeft: "0", border: "0", color: color, }}>
                            <AddShoppingCartIcon style={{ width: "1.5em", height: "1.5em" }} />
                          </Button>
                          {/* <div style={{ height: "calc(100% + -80px)", display: "flex", marginLeft: 0, marginTop: "7px", position: "relative" }} >
                            <Typography color='textSecondary' className={`${classes.text} ${classes.lightGray}`} style={{ cursor: "pointer", marginBottom: 0, color: lightGray }}
                              onClick={this.openDetails}
                              dangerouslySetInnerHTML={{ __html: this.props.danie.info }}>
                            </Typography>
                          </div> */}
                        </CardActions>
                      </Grid>


                    </Grid>
                  </Card>
                  {/* <hr className={classes.hr} style={{ width: '100%' }} /> */}

                </Paper>

              </Grid> : null} 


        {this.state.openChange ? <DialogChangeItem item={this.state.item} open={this.state.openChange} close={this.closeDialogChangeItem} /> : null}

        <Gallery className={classes.actions1} button={true} title={"zdjęcia"} visible={this.state.visible} close={this.closeGalery}
          icon="icon-picture" room={this.props.danie.asort_id.toString()} />
        <Details open={this.state.openDetails} close={this.closeDetails} data={this.props.danie} openGalery={this.openGalery} selected={this.props.selected}/>
      </Fragment>
  );
  }     
}

const styles = (theme : Theme) => ({
    paper: {
      marginBottom:"1em",
      width: "inherit"
    },
    media: {
      width: "calc(100% + -10px)",
      height: "auto",
      aspectRatio: "240/140",
      //maxHeight: "170px",
      //paddingTop: '56.25%', // 16:9
      margin: "1px 1px 8px 1px",
      //marginBottom: "8px",
      ////float: "left",
      border: "5px solid #fff",
      //overflow: "hidden",
      //position: "relative",
      //textAlign: "center",
      boxShadow: "2px 2px 3px 2px #e6e6e6",
      float: "left" as "left", 
      position: "relative" as "relative", 
      textAlign: "center" as "center",
      cursor: "pointer" as "pointer"
    },
    actions: { 
        //marginLeft:"22px",
        display: 'block'
    },
    actions1: {
      display: 'flex',
      height: "42px"
    },
    gridContainer: {
        //display: 'block'
    },
    gridContainer2: {
      //display: 'block',
      //margin: 0
    },
    grid: { 
        //height: "fit-content", 
        //float: "left" as "left"
    },
    grid2: {
        // paddingBottom: "0px", 
        // overflow: "hidden", 
        // display: "block",  
        // maxWidth: "100%"
    },
    grid3: {
        display: 'inline-block',
        position: 'relative' as 'relative'
    },
    infoOuter: {
        //paddingLeft: "42px", 
        //paddingRight: "52px",
        paddingTop: "4px"
    },
    infoInner: {
        overflow: "hidden", 
        maxHeight: "120px", 
        textAlign: "justify" as "justify",
    },
    hr: {
      border: "0",
      borderBottom: "1px solid #ddd",
    },
    actionButtons: {
      textTransform: "lowercase" as "lowercase",
      fontSize: '0.8rem'
    },
    headline: {
      whiteSpace: 'nowrap' as 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    text: {
      fontSize: "11.5px" ,
      display: "-webkit-box" as "-webkit-box",
      //"-webkit-line-clamp": "3",
      //"-webkit-box-orient": "vertical",
      overflow: "hidden" as "hidden",
      textOverflow: "ellipsis",
      textAlign: "center" as "center",
      //alignSelf: "end" as "end",
      marginBottom: "8px",

      position: "absolute" as "absolute",
      height: "100%"
    },
    lightGray: {
      color: "#888"
    },

    
  });

//export default withTranslation()(withStyles(styles)(RoomCard));


const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(KartaDanie));